import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const QuotationInvoiceTemplateV2 = ({
  headerBase64,
  footerBase64,
  dgSignBase64,
  watermarkBase64,
  quotation,
  enquiry,
  quotationData = [],
  invoice_date,
  grandTotal,
  numberToWords,
  selectedValue,
  type,
  bankAc,
  invoice_no,
  tax_type,
  tax_id,
  currency,
 scope,
}) => {
  const doc = new jsPDF("p", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const margin = 18;
  const headerHeight = 28;
  const footerHeight = footerBase64 ? 20 : 8;

  const formatDate = (value) =>
    value ? new Date(value).toLocaleDateString("en-GB") : new Date().toLocaleDateString("en-GB");

  const money = (value) =>
    Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const colors = {
    border: [60, 60, 60],
    header: [220, 220, 220],
    text: [40, 40, 40],
  };

  const addHeader = () => {
    if (headerBase64) {
      doc.addImage(headerBase64, "PNG", 0, 0, pageWidth, headerHeight);
    }
  };

  const addWatermark = () => {
    if (!watermarkBase64) return;

    const wmWidth = pageWidth / 2.2;
    const wmHeight = wmWidth;
    const wmX = (pageWidth - wmWidth) / 2;
    const wmY = (pageHeight - wmHeight) / 2;

    doc.setGState(new doc.GState({ opacity: 0.05 }));
    doc.addImage(watermarkBase64, "PNG", wmX, wmY, wmWidth, wmHeight);
    doc.setGState(new doc.GState({ opacity: 1 }));
  };

  const addFooter = () => {
    if (footerBase64) {
      doc.addImage(
        footerBase64,
        "PNG",
        0,
        pageHeight - footerHeight,
        pageWidth,
        footerHeight
      );
    }
  };

  const drawTopSection = () => {
    let y = headerBase64 ? headerHeight + 1 : 13;

    const invoiceNum =
      type === "INVOICE" ? invoice_no || "-" : quotation?.qu_no || invoice_no || "-";

    const quotationTitle = quotation?.title?.trim();

    const headingText = quotationTitle
      ? `${type} - ${quotationTitle}`
      : type;

    doc.setTextColor(...colors.text);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text(headingText, pageWidth / 2, y, { align: "center" });

    y += 3;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

      const numberLabel =
      type === "INVOICE"
        ? "Invoice No"
        : "Quotation No";

    doc.text(`${numberLabel}: ${invoiceNum}`, margin, y);
    doc.text(`Date: ${formatDate(invoice_date)}`, pageWidth - margin, y, {
      align: "right",
    });

    y += 5;

    doc.text(`To: ${enquiry?.name || "-"}`, margin, y);

    y += 5;

    doc.text("Address:", margin, y);
    doc.text(enquiry?.address || "-", margin + 12, y);

    y += 5;

    const taxValue = tax_id || enquiry?.tax_id;
    const mobileValue = enquiry?.mobile_no || "-";

    const taxLabel = tax_type ? `${tax_type} ID` : "Tax ID";

    doc.text(`${taxLabel}: ${taxValue || "-"}`, margin, y);
    doc.text(`Mobile No: ${mobileValue}`, pageWidth - margin, y, {
  align: "right",
});

    y += 3;

    return y;
  };


  const htmlToScopeLines = (html = "") => {
  const parser = new DOMParser();
  const docHtml = parser.parseFromString(html, "text/html");

  const lines = [];

  const walk = (node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const tag = node.tagName.toLowerCase();
      const text = node.textContent.trim();

      if (!text) return;

      if (tag === "h1") {
        lines.push({ text, type: "h1" });
        return;
      }

      if (tag === "h2") {
        lines.push({ text, type: "h2" });
        return;
      }

      if (tag === "h3") {
        lines.push({ text, type: "h3" });
        return;
      }

      if (tag === "li") {
        lines.push({ text: `• ${text}`, type: "li" });
        return;
      }

      if (tag === "p") {
        lines.push({ text, type: "p" });
        return;
      }
    }

    node.childNodes.forEach(walk);
  };

  docHtml.body.childNodes.forEach(walk);

  return lines;
};

const drawScopeSection = (startY) => {
  const scopeData = scope || quotation?.scope || enquiry?.scope;
  if (!scopeData) return startY;

  const scopeLines = htmlToScopeLines(scopeData);
  if (!scopeLines.length) return startY;

  const maxY = pageHeight - footerHeight - 75;
  const boxWidth = pageWidth - 2 * margin;
  let textY = startY + 7;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("Scope of the Quotation", margin, startY + 3);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6);

  for (const line of scopeLines) {
  if (line.type === "h1") {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
  } else if (line.type === "h2") {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
  } else if (line.type === "h3") {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
  } else {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
  }

  const wrapped = doc.splitTextToSize(line.text, boxWidth - 8);

  for (const wrappedLine of wrapped) {
    if (textY > maxY) {
      return textY + 4;
    }

    doc.text(wrappedLine, margin + 3, textY);
    textY += line.type?.startsWith("h") ? 4.2 : 3.2;
  }
}

  return textY  ;
};

  addHeader();
  addWatermark();

  let tableStartY = drawTopSection();
tableStartY = drawScopeSection(tableStartY);

console.log("scope prop =", scope);
console.log("quotation =", quotation);
console.log("quotation.scope =", quotation?.scope);
console.log("enquiry.scope =", enquiry?.scope);

  const tableRows = quotationData.map((item, index) => {
    const qty = parseFloat(item.qty) || 0;
    const unitPrice = parseFloat(item.unitprice) || 0;
    const total = qty * unitPrice;
   // const total =
     // item.totalprice !== undefined && item.totalprice !== null
      //  ? parseFloat(item.totalprice) || 0
      //  : qty * unitPrice;

    return [
        index + 1,
        item.description || "-",
        item.hsn_code || "-",
        item.unit || "-",
        qty.toFixed(0),
        money(unitPrice),
        money(total),
      ];
  });

  autoTable(doc, {
      startY: tableStartY,
      tableWidth: pageWidth - 2 * margin,
      head: [[
    "Sl.No",
    "Description",
    "HSN/SAC",
    "Unit",
    "Qty",
    "Unit Price",
    "Total"
  ]],
    body: tableRows,
    margin: {
      left: margin,
      right: margin,
      bottom: footerHeight + 10,
    },
    theme: "grid",
    styles: {
      fontSize: 8,
      lineColor: colors.border,
      lineWidth: 0.2,
      cellPadding: 2,
      textColor: colors.text,
    },
    headStyles: {
      fillColor: colors.header,
      textColor: colors.text,
      fontStyle: "bold",
    },
    columnStyles: {
  0: { cellWidth: 11, halign: "center" },
  1: { cellWidth: 55 },
  2: { cellWidth: 22, halign: "center" },
  3: { cellWidth: 14, halign: "center" },
  4: { cellWidth: 12, halign: "center" },
  5: { cellWidth: 28, halign: "right" },
  6: { cellWidth: 32, halign: "right" },
},
    didDrawPage: () => {
      addWatermark();
      addFooter();
    },
  });

  let subTotal = 0;
  let totalTaxAmount = 0;

  quotationData.forEach((item) => {
    const qty = parseFloat(item.qty) || 0;
    const unitPrice = parseFloat(item.unitprice) || 0;
    const itemTaxPercent = parseFloat(item.tax) || 0;
    const rowTotal = qty * unitPrice;

    subTotal += rowTotal;
    totalTaxAmount += rowTotal * (itemTaxPercent / 100);
  });

  const finalTotal =
    typeof grandTotal === "number" && grandTotal > 0
      ? grandTotal
      : subTotal + totalTaxAmount;

  const taxPercent =
    quotationData.length > 0 ? parseFloat(quotationData[0]?.tax || 0) : 0;

  let currentY = doc.lastAutoTable.finalY;



  
const formattedTotal = parseFloat(finalTotal.toFixed(2));
const rupees = Math.floor(formattedTotal);
const paise = Math.round((formattedTotal - rupees) * 100);

let words = numberToWords(rupees);

if (paise > 0) {
  words += ` and ${numberToWords(paise)} Paise`;
}

words += " Only";

autoTable(doc, {
  startY: currentY,
  tableWidth: pageWidth - 2 * margin,
  body: [
    ["Total", money(subTotal)],
    [`Tax (${taxPercent}%)`, money(totalTaxAmount)],
    ["Grand Total", money(finalTotal)],
    [`Grand Total in Words: ${words}`, ""],
  ],
  margin: {
    left: margin,
    right: margin,
    bottom: footerHeight + 10,
  },
  theme: "plain",
  styles: {
    fontSize: 8,
    cellPadding: 2,
    textColor: colors.text,
    lineColor: colors.border,
    lineWidth: 0,
    fillColor: [255, 255, 255],
  },
  columnStyles: {
    0: { cellWidth: pageWidth - 2 * margin - 32, halign: "right", fontStyle: "bold" },
    1: { cellWidth: 32, halign: "right" },
  },
  didParseCell: function (data) {
    if (data.row.index === 2) {
      data.cell.styles.fontStyle = "bold";
    }

    if (data.row.index === 3) {
      data.cell.styles.fontStyle = "bold";
      data.cell.styles.halign = "left";

      if (data.column.index === 0) {
        data.cell.colSpan = 2;
      }
    }
  },
  didDrawCell: function (data) {
    const { cell } = data;

    doc.setDrawColor(...colors.border);
    doc.setLineWidth(0.2);

    // Grand Total in Words row - full width, no inside vertical line
    if (data.row.index === 3 && data.column.index === 0) {
      doc.line(cell.x, cell.y, cell.x, cell.y + cell.height);
      doc.line(cell.x + cell.width, cell.y, cell.x + cell.width, cell.y + cell.height);
      doc.line(cell.x, cell.y, cell.x + cell.width, cell.y);
      doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
      return;
    }

    // For Total, Tax, Grand Total rows
    doc.line(cell.x, cell.y, cell.x + cell.width, cell.y);
    doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);

    if (data.column.index === 0) {
      doc.line(cell.x, cell.y, cell.x, cell.y + cell.height);
      doc.line(cell.x + cell.width, cell.y, cell.x + cell.width, cell.y + cell.height);
    }

    if (data.column.index === 1) {
      doc.line(cell.x + cell.width, cell.y, cell.x + cell.width, cell.y + cell.height);
    }
  },
  didDrawPage: () => {
    addWatermark();
    addFooter();
  },
});

currentY = doc.lastAutoTable.finalY + 4;

currentY = doc.lastAutoTable.finalY + 4;
 

  

  let finalTerms = [];

  if (selectedValue?.data) {
    const html = selectedValue.data;

    const withLineBreaks = html
      .replace(/<li[^>]*>/gi, "\n")
      .replace(/<\/li>/gi, "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<p[^>]*>/gi, "\n")
      .replace(/<\/p>/gi, "")
      .replace(/<\/?[^>]+(>|$)/g, "")
      .trim();

    finalTerms = withLineBreaks
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
  }

  if (currentY + 35 > pageHeight - footerHeight - 15) {
    doc.addPage();
    addHeader();
    addWatermark();
    currentY = headerHeight + 12;
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("Terms and condition", margin, currentY);

  currentY += 4;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.5);

  finalTerms.forEach((line) => {
    const wrapped = doc.splitTextToSize(line, pageWidth - 2 * margin);

    wrapped.forEach((wrappedLine, index) => {
      if (currentY + 5 > pageHeight - footerHeight - 15) {
        doc.addPage();
        addHeader();
        addWatermark();
        currentY = headerHeight + 12;
      }

      doc.text(`${index === 0 ? "• " : "  "}${wrappedLine}`, margin, currentY);
      currentY += 3;
    });
  });

  currentY += 3;

  if (currentY + 45 > pageHeight - footerHeight - 15) {
    doc.addPage();
    addHeader();
    addWatermark();
    currentY = headerHeight + 12;
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("Bank details", margin, currentY);

  currentY += 4;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);

  if (bankAc) {
    const bankLines = [
      `Account Holder: ${bankAc.holder_name || ""}`,
      `Bank: ${bankAc.bank_name || ""}`,
      `Account No: ${bankAc.ac_no || ""}`,
      `IFSC: ${bankAc.ifsc_code || ""}`,
      `${(bankAc.bank_address || "").replace(/\n/g, " ")}`,
    ].filter(Boolean);

    bankLines.forEach((line) => {
      doc.text(line, margin, currentY);
      currentY += 3;
    });
  }

  currentY += 2;

  const sigWidth = 30;
  const sigHeight = 40;
  const sigX = pageWidth - margin - sigWidth;
  const sigY = currentY;

  if (dgSignBase64) {
    doc.addImage(dgSignBase64, "PNG", sigX, sigY, sigWidth, sigHeight);
  }

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Seal & Signature", sigX, sigY + sigHeight + 3);

  addFooter();

  return doc;
};

export default QuotationInvoiceTemplateV2;